import React from 'react';
import styled from 'styled-components';
import EuBannerSrc from 'src/static/banner-eu.jpg';


const EuBannerStyled = styled.div`
  height: 29vw;
  background: url(${EuBannerSrc}), linear-gradient(90deg, rgba(79,133,188,1) 0%, rgba(124,165,206,1) 50%);
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: bottom;
  background-position-x: center;
`;


export default function EuBanner() {
  return (
    <EuBannerStyled>
      <EuBannerStyled />
    </EuBannerStyled>
  );
}



// WEBPACK FOOTER //
// ./src/finwhale/common/banner/EuBanner.js